import React, { Component, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";
import { useTranslation } from "react-i18next";
import FAQ from "../components/downloads/DeVilbiss_Healthcare_Oxygen_Concentrator_Recall_FAQs.pdf";
import Notice from "../components/downloads/DeVilbiss_525_Manual_Update_Customer_Notification_Letter.pdf";

export const NavMenu = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };
  const { t, i18n } = useTranslation();
  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        container
        light
        name="navigation"
      >
        <NavbarBrand tag={Link} to="/" state={{ data: true }}>
          {t("layout.home")}
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse
          className="d-sm-inline-flex flex-sm-row-reverse"
          isOpen={collapsed}
          navbar
          name="navigation"
        >
          <ul className="navbar-nav flex-grow">
            <NavItem>
              <NavLink tag={Link} className="nav-link lead" to="/ContactUs">
                {t("layout.contactUs")}
              </NavLink>
            </NavItem>
            <NavItem>
              <a
                href={Notice}
                className="nav-link lead"
                target="_blank"
                rel="noopener"
              >
                {t("layout.notice")}
              </a>
            </NavItem>
            <NavItem>
              <a
                href={t("layout.cpscLink")}
                className="nav-link lead"
                target="_blank"
              >
                {t("layout.fda")}
              </a>
            </NavItem>
            <NavItem>
              <a href={FAQ} className="nav-link lead" target="_blank">
                {t("layout.faq")}
              </a>
            </NavItem>
            {/*<NavItem>*/}
            {/*    <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>*/}
            {/*</NavItem>*/}
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};
